(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mumuso-inbox-launcher"]) return;
  try {
    
  if (!customElements.get('mumuso-inbox-launcher')) {
    customElements.define('mumuso-inbox-launcher', class extends HTMLElement {
      connectedCallback() {
        this.attempts = 0;
        this.button = this.querySelector('button');
        this.openChat = () => document.querySelector('shopify-chat')?.show();
        this.button.addEventListener('click', this.openChat);
        this.links = this.querySelectorAll('.mumuso-inbox-launcher__shortcuts a');
        this.shortcuts = this.querySelector('.mumuso-inbox-launcher__shortcuts');
        this.links.forEach((link) => {
          const section = document.querySelector(`#MainContent > [id$="${link.dataset.sectionSuffix}"]`);
          const target = section?.firstElementChild;
          if (target && !target.id) target.id = new URL(link.href).hash.slice(1);
          if (target) {
            const header = document.querySelector('header-component');
            target.style.scrollMarginTop = `${Math.max(120, (header?.getBoundingClientRect().height || 0) + 24)}px`;
            if (location.hash === `#${target.id}`) requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
          }
        });
        this.navigate = (event) => {
          const link = event.target.closest('.mumuso-inbox-launcher__shortcuts a');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          document.querySelector('shopify-chat')?.close();
          const target = document.getElementById(new URL(link.href).hash.slice(1));
          if (!target) return;
          event.preventDefault();
          const header = document.querySelector('header-component');
          target.style.scrollMarginTop = `${Math.max(120, (header?.getBoundingClientRect().height || 0) + 24)}px`;
          history.pushState(null, '', new URL(link.href).hash);
          requestAnimationFrame(() => target.scrollIntoView({behavior:'instant', block:'start'}));
        };
        this.addEventListener('click', this.navigate);
        const ready = () => {
          const chat = document.querySelector('shopify-chat');
          if (chat && typeof chat.show === 'function') {
            this.hidden = false;
            document.documentElement.classList.add('mumuso-custom-inbox');
            document.documentElement.classList.toggle('mumuso-inbox-desktop-native', this.classList.contains('hide-desktop'));
            document.documentElement.classList.toggle('mumuso-inbox-mobile-native', this.classList.contains('hide-mobile'));
            clearInterval(this.timer);
            this.stateTimer = setInterval(() => {
              this.classList.toggle('is-open', chat.open === true);
              if (chat.open && !this.shortcuts.matches(':popover-open')) this.shortcuts.showPopover();
              if (!chat.open && this.shortcuts.matches(':popover-open')) this.shortcuts.hidePopover();
            }, 250);
          } else if (++this.attempts >= 120) clearInterval(this.timer);
        };
        this.timer = setInterval(ready, 500);
        ready();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        clearInterval(this.stateTimer);
        if (this.shortcuts?.matches(':popover-open')) this.shortcuts.hidePopover();
        this.button?.removeEventListener('click', this.openChat);
        this.removeEventListener('click', this.navigate);
        document.documentElement.classList.remove('mumuso-custom-inbox','mumuso-inbox-desktop-native','mumuso-inbox-mobile-native');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mumuso-product-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-mumuso-product-carousel]');

    carousels.forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      const track = carousel.querySelector('[data-carousel-track]');
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');

      if (!track || !prev || !next) return;

      const getStep = () => {
        const card = track.querySelector('.mumuso-home__product');
        if (!card) return Math.max(track.clientWidth * 0.8, 260);
        const style = window.getComputedStyle(track);
        const gap = Number.parseFloat(style.columnGap || style.gap || '0');
        return card.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mumuso-top-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-mumuso-top-carousel]');

    carousels.forEach((carousel) => {
      if (carousel.dataset.topCarouselReady === 'true') return;
      carousel.dataset.topCarouselReady = 'true';

      const track = carousel.querySelector('[data-carousel-track]');
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');

      if (!track || !prev || !next) return;

      const getStep = () => {
        const card = track.querySelector('.mumuso-home__product');
        if (!card) return Math.max(track.clientWidth * 0.8, 260);
        const style = window.getComputedStyle(track);
        const gap = Number.parseFloat(style.columnGap || style.gap || '0');
        return card.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      requestAnimationFrame(updateButtons);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
